<template>
    <div class="is-full-width px-5">
        <div class="counterpart_table_header">
            <div class=" filter_days is-flex is-flex-direction-row is-align-items-center">
                <div class=" text cell is-flex is-align-items-center is-clickable"
                    :class="{ 'selected': selectedPeriod == today }" @click="getDocumentsByFilter(today)"> Hoy
                </div>
                <div class="text cell is-flex is-align-items-center is-clickable"
                    :class="{ 'selected': selectedPeriod == last7days }" @click="getDocumentsByFilter(last7days)">
                    7 días
                </div>
                <div class="text cell is-flex is-align-items-center is-clickable"
                    :class="{ 'selected': selectedPeriod == last30days }" @click="getDocumentsByFilter(last30days)">
                    30 días
                </div>
            </div>
            <div class="search_container is-justify-content-center">
                <SearchIcon class="search_icon" />
                <input type="text" class="search_input " v-model="searchFilter" placeholder="Buscar por nombre o rut" />
                <button v-if="searchFilter" class="clear_button" @click="searchFilter = ''">
                    <Ecs />
                </button>
            </div>
            <div class="mr-3">
                <b-checkbox class="btnNoClassify" true-value="Sin Clasificar" :false-value="''" :key="filterTable"
                    v-model="filterTable">
                    <span style="padding-left: -3px;">Sin Clasificar</span>
                </b-checkbox>
            </div>
            <div style="width: 230px;">
                <SelectComponent ref="SelectAccountComponent" :staticLabel="'Clasificados'" theme="classification_theme"
                    :isSearchable="true" :weirdOptions="usedAccounts" @selectedValues="e => updateSelectedAccounts(e)"
                    :isAccount="true" />
            </div>
        </div>
        <div v-if="this.accountFilters.length > 0" class="header_filters pl-5">
            <span v-for="(accountFilter, iAccountFilter) in accountFilters" v-bind:key="iAccountFilter">
                <span class="itemFilter mr-3" @click="() => deleteItemAccountFilter(accountFilter)"
                    v-if="accountFilter && iAccountFilter < 4">
                    {{ accountFilter }}
                    <Ecs class="ecsFilter" />
                </span>
            </span>
            <span v-if="accountFilters.length > 4" class="itemFilter">
                +{{ accountFilters.length - 4 }}
            </span>
            <div class="is-pulled-right mr-4">
                <button class="itemFilter" @click="() => clearFilteredAccounts()">
                    Limpiar Filtro
                </button>
            </div>
        </div>
        <div class="container_table_main_table main_table mb-5">
            <table class="big_table">
                <colgroup>
                    <!--nombre-->
                    <col style="width: 25%" />
                    <!--Contraparte-->
                    <col style="width: 12%" />
                    <!--Fecha de emision-->
                    <col style="width: 12%" />
                    <!--Tipo de documento-->
                    <col style="width: 12%" />
                    <!--No Doc-->
                    <col style="width: 10%" />
                    <!--Monto (CLP)-->
                    <col style="width: 12%" />
                    <!--Cuenta-->
                    <col style="width: 15%" />
                    <!--Editar-->
                    <col style="width: 2%" />
                </colgroup>
                <tr>
                    <td class="py-2">
                        <div class="header_table ml-2">
                            Nombre
                            <SortButton @click="changeOrderGeneric('name_counterpart')" class="ml-1"
                                :globalSortColumn="sortColumn" :column="'name_counterpart'"
                                :sortDirection="sortDirection">
                            </SortButton>
                        </div>
                    </td>
                    <td class="py-2">
                        <div class="header_table">
                            Contraparte
                            <SortButton @click="changeOrderGeneric('counterpart_type')" :globalSortColumn="sortColumn"
                                :column="'counterpart_type'" :sortDirection="sortDirection"></SortButton>
                        </div>
                    </td>
                    <td class="py-2">
                        <div class="header_table">
                            <span class="nobreak">Fecha de emision</span>
                            <SortButton @click="changeOrderGeneric('emitted_at')" :globalSortColumn="sortColumn"
                                :column="'emitted_at'" :sortDirection="sortDirection"></SortButton>
                        </div>
                    </td>
                    <td class="py-2">
                        <div class="header_table">
                            Tipo de documento
                            <SortButton @click="changeOrderGeneric('doc_type')" :globalSortColumn="sortColumn"
                                :column="'doc_type'" :sortDirection="sortDirection"></SortButton>
                        </div>
                    </td>
                    <td class="py-2">
                        <div class="header_table">
                            Nro Doc
                            <SortButton @click="changeOrderGeneric('doc_number')" :globalSortColumn="sortColumn"
                                :column="'doc_number'" :sortDirection="sortDirection"></SortButton>
                        </div>
                    </td>
                    <td class="py-2">
                        <div class="header_table">
                            Monto (CLP)
                            <SortButton @click="changeOrderGeneric('amount')" :globalSortColumn="sortColumn"
                                :column="'amount'" :sortDirection="sortDirection">
                            </SortButton>
                        </div>
                    </td>
                    <td class="py-2">
                        <div class="header_table">
                            Cuenta
                            <SortButton @click="changeOrderGeneric('accounts')" :globalSortColumn="sortColumn"
                                :column="'accounts'" :sortDirection="sortDirection" />
                        </div>
                    </td>
                    <td>
                        <!-- pencil -->
                    </td>
                </tr>
                <tr v-for="entry in orderedEntries" v-bind:key="entry.td_id" class="row textFormat"
                    :class="{ 'is-disabled-local': entry.cancelled }" v-show="entry.visible">
                    <!-- <tr class="row textFormat"> -->
                    <td style="height: 60px;">
                        <div class="ml-2 is-full-height is-flex is-align-items-center">
                            <span v-if="!entry.was_reviewed_by_user" class="punto_verde mr-2"></span>
                            <div class="has-text-left">
                                <div class="c_alias">
                                    {{ entry.name_counterpart }}
                                </div>
                                <div class="c_rut">
                                    {{ entry.rut_counterpart }}
                                </div>
                            </div>
                        </div>
                    </td>
                    <td style="height: 60px;">
                        <div class="is-full-height is-align-content-center">
                            <span :class="[
                                'pill',
                                'pill_' +
                                entry.counterpart_type
                                    .toLowerCase()
                                    .replace(' ', '_'),
                            ]">
                                {{ entry.counterpart_type }}
                            </span>
                        </div>
                    </td>
                    <td style="height: 60px;">
                        <div class="is-full-height is-flex is-align-items-center">
                            {{ entry.emitted_at }}
                        </div>
                    </td>
                    <td style="height: 60px;">
                        <div class="is-full-height is-flex is-align-items-center">
                            {{ getObligationTypeLabel(entry.doc_type) }}
                        </div>
                    </td>
                    <td style="height: 60px;">
                        <div class="is-full-height is-flex is-align-items-center">
                            <span v-if="entry.doc_type == 'remuneracion-clf'" class="is-capitalized">
                                {{ getFormattedDate(entry.emitted_at, 'MMM-YYYY') }}
                            </span>
                            <span v-else> {{ entry.doc_number }} </span>
                        </div>
                    </td>
                    <td style="height: 60px;">
                        <div class="is-full-height is-flex is-align-items-center">{{ money(entry.amount) }}</div>
                    </td>
                    <td style="height: 60px;">
                        <div v-if="entry.cancelled && entry.doc_type != 'Boleta de Honorarios'"
                            class="is-full-height is-flex is-align-items-center ">
                            <span>Anulado por NC: {{ entry.nc_doc_number }}</span>
                        </div>
                        <div v-if="entry.cancelled && entry.doc_type == 'Boleta de Honorarios'"
                            class="is-full-height is-flex is-align-items-center ">
                            <span>Anulada</span>
                        </div>
                        <div v-else-if="entry.accounts.length > 0"
                            class="is-full-height is-flex is-align-items-center ">
                            <span v-for="account in entry.accounts" v-bind:key="account.level_3"
                                class="square_pill pill_mother_account grey_pill nobreak">{{ account.level_3 }}</span>
                        </div>
                        <div v-else-if="entry.accounts_doc.length > 0"
                            class="is-full-height is-flex is-align-items-center ">
                            <div class=" is-flex is-align-items-center has-tooltip mr-1">
                                <RobotFace />
                                <div class="tooltip-bubble">Clasificación automática</div>
                            </div>

                            <span v-for="account in entry.accounts_doc" v-bind:key="account"
                                class="square_pill pill_mother_account grey_pill nobreak">{{ account }}</span>
                        </div>
                        <div v-else class="is-full-height is-flex is-align-items-center"
                            @click="() => openAccountByCompanyModal(entry)">
                            <div class="square_pill pill_clasificar is-clickable">
                                <EditPencil class="mr-1" />
                                Clasificar
                            </div>
                        </div>
                    </td>
                    <td style="height: 60px;">
                        <div v-if="!entry.cancelled"
                            class="ml-1 is-full-height is-flex is-align-items-center is-clickable"
                            @click="() => openAccountByCompanyModal(entry)">
                            <EditPencil class="mr-1 my-2" />
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import SelectComponent from "@/components/classification/SelectComponent";
import ClassifyAccountAttributes from "@/components/modals/ClassifyAccountAttributes";
import SortButton from "@/components/modals/SortButton.vue";
import Ecs from "@/components/svg/Ecs.vue";
import EditPencil from "@/components/svg/EditPencil.vue";
import RobotFace from "@/components/svg/RobotFace.vue";
import SearchIcon from "@/components/svg/SearchIcon.vue";
import { parseToMoney } from "@/utils/currency";
import moment from "moment";
import { mapActions, mapState } from "vuex";
export default {
    name: "BodyLastDocuments",
    components: {
        SortButton,
        SearchIcon,
        SelectComponent,
        Ecs,
        EditPencil,
        RobotFace,
    },
    data() {
        return {
            orderedEntries: [],
            actualPage: 1,
            maxPages: 1,
            accountFilters: [],
            filterTable: '',
            getPaginatedList: [],
            sortColumn: "order",
            sortDirection: "asc",
            searchFilter: '',
            today: null,
            last7days: null,
            last30days: null,
            selectedPeriod: null,
            usedAccounts: [],
            modalDefault: {
                parent: this,
                hasModalCard: true,
                customClass: "modal-class",
                canCancel: ["escape", "outside"],
            },
        }
    },
    methods: {
        ...mapActions("classification", ["getDocuments"]),
        money(value) {
            if (value != "") {
                return parseToMoney(value);
            }
        },
        getObligationTypeLabel(obligationName) {
            let searched = this.typeFiles.find(typeFile => typeFile.value == obligationName)
            if (!searched) {
                searched = { label: obligationName }
            } else if (obligationName == 'remuneracion-clf') {
                searched = { label: 'Remuneración' }
            }
            return searched.label
        },
        updateSelectedAccounts(accountsSelected) {
            if (accountsSelected.length != 0) {
                this.filterTable = ''
            }
            this.accountFilters = [...accountsSelected]
            this.allFiltersToEntries()
        },
        changeDirectionData() {
            if (this.sortDirection == "order") {
                this.sortDirection = "desc";
            } else if (this.sortDirection == "desc") {
                this.sortDirection = "asc";
            } else if (this.sortDirection == "asc") {
                this.sortDirection = "order";
                this.sortColumn = "order";
            }
        },
        sortPartiallyDocs(docsToSort = []) {
            return docsToSort.sort((a, b) => {
                let col_name = this.sortColumn;
                const valA = a[col_name];
                const valB = b[col_name];
                if (col_name == 'amount' && valA == valB) {
                    const dateA = new Date(a['emitted_at'])
                    const dateB = new Date(b['emitted_at'])
                    return this.sortDirection === "asc" ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
                } else if (col_name == 'amount' && valA != valB) {
                    return this.sortDirection === "asc" ? valA - valB : valB - valA;
                } else if (col_name == 'name_counterpart' && valA == valB) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'name_counterpart' && valA != valB) {
                    const compareVal = valA.localeCompare(valB)
                    return this.sortDirection === "asc" ? -compareVal : compareVal;
                } else if (col_name == 'counterpart_type' && valA == valB) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'counterpart_type' && valA != valB) {
                    const compareVal = valA.localeCompare(valB)
                    return this.sortDirection === "asc" ? -compareVal : compareVal;
                } else if (col_name == 'doc_type' && valA == valB) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'doc_type' && valA != valB) {
                    const compareVal = valA.localeCompare(valB)
                    return this.sortDirection === "asc" ? -compareVal : compareVal;
                } else if (col_name == 'emitted_at' && valA == valB) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'emitted_at' && valA != valB) {
                    const dateA = new Date(valA)
                    const dateB = new Date(valB)
                    return this.sortDirection === "asc" ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
                } else if (col_name == 'doc_number' && valA == valB) {
                    const dateA = new Date(a['emitted_at'])
                    const dateB = new Date(b['emitted_at'])
                    return this.sortDirection === "asc" ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
                } else if (col_name == 'doc_number' && valA != valB) {
                    const maskedValA = valA.padStart(valB.length, "0");
                    const maskedValB = valB.padStart(valA.length, "0");
                    const compareVal = maskedValA.localeCompare(maskedValB)
                    return this.sortDirection === "asc" ? compareVal : -compareVal;
                } else if (col_name == 'accounts' && valA.length == valB.length && valA.length == 0) {
                    const subValA = a['amount'];
                    const subValB = b['amount'];
                    return this.sortDirection === "asc" ? subValA - subValB : subValB - subValA;
                } else if (col_name == 'accounts') {
                    let auxA = valA
                    let auxB = valB;
                    if (auxA.length == 0) {
                        auxA = { level_3: a['accounts_doc'] }
                    }
                    if (auxB.length == 0) {
                        auxB = { level_3: b['accounts_doc'] }
                    }
                    if (auxA.length > 0 && auxB.length == 0) {
                        return 1
                    } else if (auxA.length == 0 && auxB.length > 0) {
                        return -1
                    }
                    if (auxA[0].level_3 == auxB[0].level_3) {
                        const subauxA = a['amount'];
                        const subauxB = b['amount'];
                        return subauxB - subauxA;
                    }
                    const compareVal = auxA[0].level_3.replaceAll(' ', '_').localeCompare(auxB[0].level_3.replaceAll(' ', '_'))
                    return this.sortDirection === "asc" ? -compareVal : compareVal;
                } else {
                    return this.sortDirection === "asc" ? valA.length - valB.length : valB.length - valA.length;
                }
            });
        },
        sortAllDocuments() {
            const documentsNotAnnulled = this.lastDocuments.filter(doc => !doc.cancelled)
            const documentsAnnulled = this.lastDocuments.filter(doc => doc.cancelled)
            const orderedDocsNotAnnulled = this.sortPartiallyDocs(documentsNotAnnulled)
            const orderedDocsAnnulled = this.sortPartiallyDocs(documentsAnnulled)
            this.orderedEntries = [...orderedDocsNotAnnulled, ...orderedDocsAnnulled]
        },
        changeOrderGeneric(column) {
            if (this.sortColumn != column) {
                this.sortDirection = "order"
                this.sortColumn = column;
            }
            this.changeDirectionData();
            this.sortAllDocuments();
        },
        deleteItemAccountFilter(item) {
            this.$refs.SelectAccountComponent.deleteItemCbList(item)
        },
        clearFilteredAccounts() {
            this.$refs.SelectAccountComponent.clearCbList()
            this.allFiltersToEntries()
        },
        isEntryFilteredBySearch(entry) {
            const filter = this.searchFilter.trim().toLowerCase();
            if (filter == "") {
                return true
            } else {
                return entry.name_counterpart.toLowerCase().indexOf(filter) >= 0 ||
                    entry.rut_counterpart.toLowerCase().indexOf(filter) >= 0
            }
        },
        allFiltersToEntries() {
            this.actualPage = 1
            this.orderedEntries = this.lastDocuments.map(entry => {
                entry.visible = this.isEntryFilteredBySearch(entry) &&
                    (
                        (
                            this.filterTable == 'Sin Clasificar' &&
                            entry.accounts.length == 0 &&
                            entry.accounts_doc.length == 0
                        ) ||
                        (
                            this.filterTable == '' && (
                                entry.accounts.some(
                                    account => this.accountFilters.includes(account.level_3)
                                ) || (
                                    entry.accounts.length == 0 &&
                                    entry.accounts_doc.some(
                                        account => this.accountFilters.includes(account)
                                    )
                                ) ||
                                this.accountFilters.length == 0
                            )
                        )
                    )
                return entry
            })
            this.sortAllDocuments();
        },
        openAccountByCompanyModal(document) {
            try {
                const contraparte = {
                    ci_id: document.ci_id,
                    pay_or_charge: document.pay_or_charge_doc,
                    obligation_name: document.doc_type
                }

                this.$buefy.modal.open({
                    ...this.modalDefault,
                    component: ClassifyAccountAttributes,
                    customClass: "classify_modal_width",
                    props: {
                        rangeFromMainScreen: this.periodDataSelect[4].value,
                        counterpart: contraparte,
                    },
                    events: {
                        reloadCounterpart: () => {
                            this.getDocumentsByFilter(this.selectedPeriod)
                        },
                    },
                });
            } catch (err) {
                console.log("error?:", err);
            }
        },
        async getDocumentsByFilter(newPeriod) {
            this.selectedPeriod = newPeriod
            await this.getDocuments({
                type: 'last',
                from: this.selectedPeriod,
                obligation_name: 'all'
            })
            this.allFiltersToEntries()
            this.getAllAccountsUsed()
            this.sortAllDocuments();
        },
        getAllAccountsUsed() {
            let accounts = []
            this.allAccounts.map(account => {
                let accountFound = ''
                this.lastDocuments.map(lastDoc => {
                    if (lastDoc.accounts.some(ldAccount => ldAccount.level_3 == account.level_3)) {
                        accountFound = account.level_3
                    }

                    if (lastDoc.accounts_doc.some(ldAccount => ldAccount == account.level_3)) {
                        accountFound = account.level_3
                    }
                })
                if (accountFound != '') {
                    accounts.push(account)
                }
            })

            this.usedAccounts = [...accounts]
        },
        initDateByStr(emittedDate) {
            const stuckTime = 'T00:00:00'
            let date = new Date(emittedDate + stuckTime)
            return new Date(date.getFullYear(), date.getMonth(), date.getDate())
        },
        getFormattedDate(emittedDate, format = 'DD-MM-YYYY') {
            const date = this.initDateByStr(emittedDate)
            return moment(date).format(format).replace('.', '');
        },
    },
    computed: {
        ...mapState("classification", ["lastDocuments", "periodDataSelect", "allAccounts"]),
        ...mapState('uploadFiles', ["typeFiles"]),
    },
    mounted() {
        const date = new Date()
        this.today = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate() - 1,
        );
        this.today.setHours(0, 0, 0, 0);
        this.last7days = new Date(
            this.today.getFullYear(),
            this.today.getMonth(),
            this.today.getDate() - 7,
        );
        this.last30days = new Date(
            this.today.getFullYear(),
            this.today.getMonth(),
            this.today.getDate() - 30
        );
        this.changeOrderGeneric('emitted_at')
        this.getDocumentsByFilter(this.today)
    },
    watch: {
        searchFilter() {
            this.allFiltersToEntries()
        },
        filterTable(newFilter) {
            if (newFilter) {
                this.$refs.SelectAccountComponent.clearCbList()
            }
            this.allFiltersToEntries()
        }
    }
}
</script>
<style scoped lang="scss">
* {
    font-family: Inter;
}

.has-tooltip {
    position: relative;
    display: inline-block;

    .tooltip-bubble {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        background: black;
        color: white;
        border: 2px solid #333;
        padding: 0.5em 1em;
        border-radius: 0.5em;
        white-space: nowrap;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.2s ease;
        z-index: 10;

        &::after {
            content: '';
            position: absolute;
            top: 95%;
            left: 50%;
            transform: translateX(-50%);
            border: 8px solid transparent;
            border-top-color: black;
        }
    }

    &:hover .tooltip-bubble {
        opacity: 1;
    }
}

.punto_verde {
    display: inline-block;
    width: 0.6em;
    height: 0.6em;
    background-color: #17B26A;
    border-radius: 50%;
    margin-right: 0.5em;
    vertical-align: middle;
}

.textFormat {
    color: var(--Gray-600, #475467);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
}

.row {
    border-top: 1px solid #eaecf0;
}

.header_filters {
    background-color: #eaecf0;
    height: 30px;
}

.ecsFilter {
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
    margin-bottom: -5px;
}

.itemFilter {
    padding: 2px 4px 2px 8px;
    align-items: center;
    gap: 2px;
    border-radius: 6px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--Base-White, #FFF);

    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    color: var(--Gray-700, #344054);
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
}

.counterpart_table_header {
    background-color: #eaecf0;
    height: 60px;
    width: 100%;
    padding: 12px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;

    .filter_days {
        // border-radius: 8px;
        // border: 1px solid var(--Gray-300, #D0D5DD);
        box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
        background-color: var(--Base-White, #FFF);
        height: 40px;

        .cell {
            padding-inline: 16px;
            border-right: 1px solid var(--Gray-300, #D0D5DD);
            height: 100%;
            max-height: 100%;
            border: 1px solid var(--Gray-300, #D0D5DD);
        }

        .cell:first-of-type {
            border-start-start-radius: 8px;
            border-end-start-radius: 8px;
        }

        .cell:last-of-type {
            border-start-end-radius: 8px;
            border-end-end-radius: 8px;
        }

        .text {
            color: var(--Gray-700, #344054);
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
        }

        .selected {
            background-color: #002E33;
            color: white;
        }
    }

    .search_container {
        display: flex;
        align-items: center;
        flex: 1;
        padding: 0 10px;

        .search_icon {
            position: relative;
            top: 0;
            left: -5px;
            z-index: 2;
        }

        .search_input {
            width: clamp(100px, 25vw, 300px);
            position: relative;
            left: -30px;
            box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
            border-radius: 8px;
            background-color: #fff;
            border: 1px solid #d0d5dd;
            box-sizing: border-box;
            overflow: hidden;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            padding: 8px 8px 8px 27px;
            text-align: left;
            font-size: 14px;
            color: #667085;
            font-family: Inter;
            z-index: 1;
            padding-right: 30px;
        }

        .clear_button {
            position: relative;
            left: -60px;
            top: 16px;
            transform: translateY(-50%);
            background: transparent;
            border: none;
            font-size: 16px;
            cursor: pointer;
            color: #888;
            z-index: 2;
        }
    }
}

.btnNoClassify {
    padding: 10px 14px;
    align-items: center;
    gap: 8px;
    color: var(--Gray-900, #101828);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;

    border-radius: 8px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--Base-White, #FFF);

    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    height: 46px;
}


.container_table_main_table {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #eaecf0;
    overflow-y: auto;
    max-height: 70vh;
    scrollbar-width: none;
}

.main_table {
    border-collapse: collapse;
    min-height: 70vh;
    max-height: 75vh;
}

.big_table {
    width: 100%;
    border-spacing: 0px;
    border-collapse: collapse;
}

.header_table {
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fcfcfd;
    box-sizing: border-box;
    text-align: left;
    font-size: 12px;
    color: #475467;

}

.c_alias {
    line-height: 20px;
    text-transform: uppercase;
    font-weight: 400;
    line-height: 20px;
    color: #101828;
}

.c_rut {
    font-size: 80%;
    font-weight: 500;
    line-height: 20px;
    color: #465467;
}

.square_pill {
    position: relative;
    border-radius: 4px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0px 2px 1px 2px;
    text-align: center;
    font-size: 12px;
    width: min-content;
    min-width: 4em;
}

.grey_pill {
    background-color: #eaecf0;
    border: 1px solid #d0d5dd;
}

.pill_mother_account {
    line-break: auto;
    display: block;
    color: #475467;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill {
    position: relative;
    border-radius: 16px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0px 8px 1px 8px;
    text-align: center;
    font-size: 12px;
    font-family: Inter, "Open Sans", sans-serif;
    width: min-content;
    overflow-wrap: break-word;
    word-wrap: break-word;
    min-width: 4em;
}

.pill_proveedor {
    color: #b93815;
    background-color: #fef6ee;
    border: 1px solid #f9dbaf;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_proveedor::before {
    content: "💼";
    margin-right: 3px;
}

.pill_cliente {
    color: #067647;
    background-color: #ecfdf3;
    border: 1px solid #abefc6;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_cliente::before {
    content: "🤝";
    margin-right: 3px;
}

.pill_trabajador {
    color: #5925dc;
    background-color: #f4f3ff;
    border: 1px solid #d9d6fe;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_trabajador::before {
    content: "‍‍🧑‍💻";
    margin-right: 3px;
}

.pill_honorario {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_honorario::before {
    content: "‍🕒";
    margin-right: 3px;
}

.pill_internacional {
    color: #175cd3;
    background-color: #eff8ff;
    border: 1px solid #b2ddff;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_internacional::before {
    content: "🌍";
    margin-right: 3px;
}

.pill_finiquito {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_finiquito::before {
    content: "📄";
    margin-right: 3px;
}

.pill_recibo {
    color: #c11574;
    background-color: #fdf2fa;
    border: 1px solid #fcceee;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_recibo::before {
    content: "🧾";
    margin-right: 3px;
}

.pill_clasificar {
    position: relative;
    box-shadow: 0px 1px 8px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fef3f2;
    border: 1px solid #fecdca;
    box-sizing: border-box;
    width: 103px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    gap: 4px;
    text-align: left;
    font-size: 12px;
    color: #b42318;
    font-family: Inter;
    font-weight: 600;
}
</style>